import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  tabPanel: {
    padding: "20px 20px 28px",
  },

  sectionLabel: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#8b7d6f",
    marginBottom: 12,
  },

  requiredStar: {
    color: "#ef7d00",
  },

  uploadBox: {
    minHeight: 70,
    border: "1px dashed #d9c9bc",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    cursor: "pointer",
    backgroundColor: "#fff",
  },

  currentUploadBox: {
    borderColor: "#ef7d00",
    minHeight: 68,
  },

  previousUploadBox: {
    minHeight: 44,
    marginTop: 12,
  },

  uploadBoxDisabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },

  uploadIcon: {
    fontSize: 22,
    color: "#8f8b86",
    marginBottom: 6,
  },

  uploadText: {
    fontSize: 14,
    color: "#8f8b86",
  },

  uploadDot: {
    margin: "0 6px",
  },

  currentDocumentCard: {
    border: "1px solid #e7ddd3",
    borderRadius: 10,
    backgroundColor: "#fff",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },

  currentDocumentLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
  },

  currentDocumentIconBox: {
    width: 34,
    height: 34,
    borderRadius: 8,
    backgroundColor: "#fff2e8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  currentDocumentIcon: {
    color: "#ef7d00",
    fontSize: 18,
  },

  currentDocumentActions: {
    display: "flex",
    gap: 8,
    flexShrink: 0,
  },

  previousDocumentRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "10px 0",
    borderBottom: "1px solid #eee5dc",
  },

  previousDocumentLeft: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
  },

  previousDocumentRight: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexShrink: 0,
  },

  documentName: {
    fontSize: 15,
    fontWeight: 500,
    color: "#16325c",
  },

  documentMeta: {
    fontSize: 14,
    color: "#8f8b86",
  },

  uploadDialogPaper: {
    borderRadius: 16,
  },

  uploadDialogContent: {
    padding: "28px 24px 24px !important",
  },

  uploadDialogHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  uploadDialogTitle: {
    fontSize: 30,
    fontWeight: 700,
    color: "#16325c",
  },

  modalUploadBox: {
    minHeight: 100,
    border: "1px dashed #ded6cd",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    cursor: "pointer",
    backgroundColor: "#fff",
  },

  modalHelperText: {
    marginTop: 8,
    fontSize: 13,
    color: "#8f8b86",
  },

  uploadDialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 22,
  },
}));
